// aiAssessment component translations
export default {
  // AI Assistant content
  assistant: {
    title: "I am TuLian AI Assistant Xiao Tu",
    description:
      "I integrate large language models with Beiming Technology's rich analytical experience to assist you in address analysis and answer any questions about cryptocurrencies.",
  },

  // Placeholder text
  placeholder:
    'Please enter a valid blockchain address for analysis\nYou can try asking like this: "Help me comprehensively analyze the transaction data of address TWpMnUh9pZS1Mf8yyy9WPiS82WYevKzQo2 on the Tron chain for the main currency"',

  // Tooltips
  tooltips: {
    historicalRecords: "Chat History",
  },

  // Example cards
  examples: {
    example1: "Analyze USDT outflow on Tron, address is TFP...z7f",
    example2: "Comprehensive analysis of TWpM...Qo2",
    fullExample1:
      "Analyze USDT outflow on Tron, address is TFPgHWmveJ8CA4cyKXFq2mik8AbQemuz7f",
    fullExample2:
      "Comprehensive analysis of TWpMnUh9pZS1Mf8yyw9WPiS82WYevKzQo2",
  },
};
